import React from 'react';
import PropTypes from 'prop-types';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PropertyAttrFormatter from '../../../helpers/PropertyAttrFormatter';
import Assets, { getAssetDomainOld } from '../../../constants/assets';
import { HISTORIC } from '../../../constants/propertyDetail';
import tooltipText from '../../../constants/tooltipText';
import ButtonWithTooltip from '../../common/ButtonWithTooltip';
import MUITooltip from '../../common/MUITooltip';


const Attributes = (props) => {
    const {
        attributes,
        disableBedrooms,
        disableBathrooms,
        disableCarSpaces,
        disableLandArea,
        disableFloorArea,
        showUpdateData,
        leftTooltip,
        propertyId,
        openUpdateModal,
        isHistoricProperty,
        isPrintPdpPage,
    } = props;
    const refinedPropertyAttributes = PropertyAttrFormatter.refinePropertyAttributes(attributes);
    const imgIconClass = 'half-opacity';
    const {
        landArea,
        isCalculatedLandArea,
        calculatedLandArea,
    } = attributes || {};
    const showLandAreaTooltip = !isPrintPdpPage &&
        (!!parseInt(landArea, 10) &&
        (isCalculatedLandArea || calculatedLandArea))
    return (
        <ul className="list-inline">
            {
                !disableBedrooms &&
                <li>
                    <div className="property-attribute" type="bed" data-testid="property-attr-bed">
                        <div className="property-attribute-val">
                            <span>
                                {Assets.ATTRIBUTES.BEDS}
                                <span>{refinedPropertyAttributes.bedrooms}</span>
                            </span>
                        </div>
                    </div>
                </li>
            }
            {
                !disableBathrooms &&
                <li>
                    <div className="property-attribute" type="bath" data-testid="property-attr-bath">
                        <div className="property-attribute-val">
                            <span>
                                {Assets.ATTRIBUTES.BATHS}
                                <span>{refinedPropertyAttributes.bathrooms}</span>
                            </span>
                        </div>
                    </div>
                </li>
            }
            {
                !disableCarSpaces &&
                <li>
                    <div className="property-attribute" type="car" data-testid="property-attr-car">
                        <div className="property-attribute-val">
                            <span>
                                {Assets.ATTRIBUTES.CARS}
                                <span>{refinedPropertyAttributes.carSpaces}</span>
                            </span>
                        </div>
                    </div>
                </li>
            }
            {
                !disableLandArea &&
                <li>
                    <div type="land-area" className="property-attribute" data-testid="property-attr-land-area">
                        <div className="property-attribute-val" data-testid="val-land-area">
                            <span>
                                {Assets.ATTRIBUTES.LANDSIZE}
                                <span>
                                    { refinedPropertyAttributes.landArea.value }
                                </span>
                            </span>
                            <span className="property-attribute-unit">
                                <span>{refinedPropertyAttributes.landArea.unit}</span>
                                {
                                    showLandAreaTooltip &&
                                    <div className="land-area-tool-tip-div" data-testid="landArea-tooltip">
                                        <MUITooltip
                                            data-testid={`mui-tooltip-${propertyId}`}
                                            title={tooltipText.TEXT.LAND_SIZE}
                                            placement={leftTooltip ? 'left' : 'right'}
                                            arrow
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            PopperProps={{
                                                sx: { zIndex: 9999 }
                                            }}
                                        >
                                            <HelpOutlineIcon
                                                style={{
                                                    fontSize: '14px',
                                                    marginLeft: '4px',
                                                }}
                                            />
                                        </MUITooltip>
                                    </div>
                                }
                            </span>
                        </div>
                    </div>
                </li>
            }
            {
                !disableFloorArea &&
                <li>
                    <div className="property-attribute" type="floor-area" data-testid="property-attr-floor-area">
                        <div className="property-attribute-val" data-testid="val-floor-area">
                            <span>
                                <img src={getAssetDomainOld('floor@2x.png')} className={imgIconClass} alt="Floor Area" width="25px" />
                                <span>
                                    { refinedPropertyAttributes.floorArea.value }
                                </span>
                            </span>
                            <span className="property-attribute-unit">
                                <span>{refinedPropertyAttributes.floorArea.unit}</span>
                            </span>
                        </div>
                    </div>
                </li>
            }
            {
                showUpdateData &&
                <ButtonWithTooltip
                    className="update-data-button"
                    onClick={openUpdateModal}
                    tooltipMessage={HISTORIC.FEATURE_NOT_AVAILABLE}
                    tooltipPosition="bottom"
                    tooltipId="update-data-button-tooltip"
                    isDisabled={isHistoricProperty}
                    displayTooltip={isHistoricProperty}
                >
                    Update data
                </ButtonWithTooltip>
            }
        </ul>
    );
};

Attributes.propTypes = {
    propertyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    leftTooltip: PropTypes.bool,
    attributes: PropTypes.object,
    disableBedrooms: PropTypes.bool,
    disableBathrooms: PropTypes.bool,
    disableCarSpaces: PropTypes.bool,
    disableLandArea: PropTypes.bool,
    disableFloorArea: PropTypes.bool,
    showUpdateData: PropTypes.bool,
    openUpdateModal: PropTypes.func,
    isHistoricProperty: PropTypes.bool,
    isPrintPdpPage: PropTypes.bool,
};

export default Attributes;
